import PerfectScrollbar from "perfect-scrollbar";
import { testIfDesktop } from "../testIfDesktop";
import "./perfect-scrollbar.css";

export class PerfectScrollbarWrapper {
	private static isDesktop = testIfDesktop();
	private scrollbar: PerfectScrollbar | undefined;

	attach(element: Element): void {
		if (!this.scrollbar && PerfectScrollbarWrapper.isDesktop) {
			this.scrollbar = new PerfectScrollbar(element);
			this.scrollbar.update();
		}
	}

	detach() {
		if (this.scrollbar) {
			this.scrollbar.destroy();
			this.scrollbar = undefined;
		}
	}
}
